import axiosConfig from './Config';

const RequestInformation ={
    SendRequestInfo: (body) => axiosConfig.post(`send-inquire`, body),
}


export default RequestInformation;